enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.TherapeuticAreaAutocomplete.request',
	receive = 'MedicinalBrandsAnalytics.TherapeuticAreaAutocomplete.receive',
}

export default ActionTypes;
